import PropTypes from 'prop-types';
/* eslint-disable camelcase */
import React from 'react';

/**
 * Creates the added Twitter meta tags given
 */

const createOgTags = ({ title, description, media }) => {
    // Create new list with meta and add the current locale directly
    const twitterDescription = description || null;
    const twitterTitle = title || null;
    const twitterImage = media ? `${media}?w=1200&h=675&fit=clip&crop=entropy&q=70&fm=jpg&auto=format` : null; // Twitter wants specific widths and heights on their images;

    return (
        <>
            {twitterTitle && <meta property="twitter:title" content={twitterTitle} />}
            {twitterDescription && <meta property="twitter:description" content={twitterDescription} />}
            {twitterImage && <meta property="twitter:image" content={twitterImage} />}
        </>
    );
};

createOgTags.propTypes = {
    description: PropTypes.string,
    media: PropTypes.string,
    title: PropTypes.string,
};

createOgTags.defaultProps = {
    description: '',
    media: '',
    title: '',
};

export default createOgTags;
